import React, { ReactElement } from 'react';
import { StepStatusInfo } from 'containers/facialRecognition/types';
import { classes } from './StepInfoTitle.style';

export type StepInfoTitleProps = {
  title?: string;
  description?: string;
  subtitle?: string;
  withBottomBorder?: boolean;
  hideOnMobile?: boolean;
  stepNumberInfo?: StepStatusInfo;
};

export function StepInfoTitle(props: StepInfoTitleProps): ReactElement {
  const { title, subtitle, withBottomBorder, hideOnMobile, description } =
    props;

  return (
    <div className={classes.container(withBottomBorder, hideOnMobile)}>
      <div className="odin-flex odin-justify-between sm:odin-block sm:odin-space-y-2">
        <div className="odin-space-y-2">
          <h2 className={classes.title}>{title}</h2>
          {description && (
            <div className={classes.subtitle}>
              {description}
              <br />
              &nbsp;
            </div>
          )}
          <div className={classes.subtitle}>{subtitle}</div>
        </div>
      </div>
    </div>
  );
}
